const UNSAFE_FILENAME_CHARS = /[:/\\*?"<>|]/g;

export function sanitizeFileName(name: string): string {
  return name.replace(UNSAFE_FILENAME_CHARS, '').replaceAll('.', '');
}
